var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.uri)?_c('div',{staticClass:"hero__video hero__video--mood"},[_c('video-component',{attrs:{"uri":_vm.uri,"quality":"hd","autoplay":"","muted":"","loop":"","playsinline":""}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }